var translation = {
	Navatar: {
		header: "AWS 个人资料",
		subheader: "您的个人资料有助于改善您与精选 AWS 体验的交互。",
		profileButtonText: "查看个人资料",
		logOutText: "注销",
		logInText: "登录",
		createProfileText: "创建个人资料",
		federateLoginModalTitle: "使用 Midway 访问您的 AWS 个人资料",
		federateLoginModalFirstDescription: "作为 Amazon 员工，我们推荐您使用 Midway 访问您的 AWS 个人资料。这一安全推荐方法可实现与内部系统的无缝集成。",
		federateLoginModalSecondDescription: "您之所以看到此消息，是因为您当前使用 AWS 构建者 ID 并以 Amazon 电子邮件地址进行登录。此提示将在您每次登录时显示，直到您切换至 Midway 或者选择继续使用当前登录方式。",
		federateLoginModalPrimaryButton: "使用 Midway 登录",
		federateLoginModalSecondaryButton: "继续使用 AWS 构建者 ID"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
